import { ReactNode, ReactElement } from "react";

type Props = {
  wrapper: (props: ReactNode) => ReactElement; // Ensure it returns a ReactElement
  children: ReactNode;
  wrap: boolean;
};

export function ComponentWrapperHOC({
  children,
  wrap,
  wrapper,
}: Props): ReactElement | null {
  return wrap ? wrapper(children) : (children as ReactElement | null);
}
